/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  OtherAdviser,
  Address,
  PersonalTitle
) => {
  /**
   * Prepare other advisers details.
   *
   * @param {Array} otherAdvisers
   * @param {Array} displayingTypes
   * @param {Array} contacts
   * @param {Array} homeLoanSecurities
   * @param {Object} insurance
   * @param {Object} workflow
   *
   * @returns {Array}
   */
  const prepareOtherAdvisersDetails = ({
    otherAdvisers,
    displayingTypes,
    contacts,
    homeLoanSecurities,
    insurance,
    workflow
  }) => {
    const content = [];
    if (otherAdvisers?.length && contacts?.length) {
      content.push({
        text: 'OTHER ADVISERS',
        pageBreak: helperService.getOrganizationCountry().cca2 === 'NZ' ? '' : 'before',
        style: ['header']
      });
      const hasPersonContact = _.some(contacts, (c) => !c.isCompany);
      let accountantCount = 0;
      let solicitorCount = 0;
      let realEstateAgentCount = 0;
      let financialAdvisorCount = 0;
      let generalInsuranceAgentCount = 0;
      let primaryBankerCount = 0;
      const len = otherAdvisers.length;
      for (let o = 0; o < len; o += 1) {
        const otherAdviser = otherAdvisers[o];
        if (
          otherAdviser.isOtherAdviserAccountantType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          accountantCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${accountantCount}`
            })
          );
        }
        if (
          otherAdviser.isOtherAdviserSolicitorType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          solicitorCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${solicitorCount}`
            })
          );
        }
        if (
          otherAdviser.isOtherAdviserRealEstateType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          realEstateAgentCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${realEstateAgentCount}`
            })
          );
        }
        if (
          otherAdviser.isOtherAdviserFinancialAdvisorType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          financialAdvisorCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${financialAdvisorCount}`
            })
          );
        }
        if (
          otherAdviser.isOtherAdviserGeneralInsuranceAgentType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          generalInsuranceAgentCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${generalInsuranceAgentCount}`
            })
          );
        }
        if (
          otherAdviser.isOtherAdviserPrimaryBankerType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          primaryBankerCount += 1;
          content.push(
            helperPdfService.createSubHeader({
              title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${primaryBankerCount}`
            })
          );
        }
        if (
          !otherAdviser.isOtherAdviserPrimaryBankerType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Firm\n', style: 'label' },
                      {
                        text: otherAdviser?.companyName || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Title\n', style: 'label' },
                      {
                        text:
                          otherAdviser?.contactTitle?.name !== PersonalTitle.none.name
                            ? otherAdviser?.contactTitle?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Contact person (first name)\n', style: 'label' },
                      {
                        text: otherAdviser?.contactFirstName || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Contact person (surname)\n', style: 'label' },
                      {
                        text: otherAdviser?.contactLastName || '-',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Phone number\n', style: 'label' },
                      {
                        text: `${
                          otherAdviser?.contactPhone ? otherAdviser?.contactPhoneCode : ''
                        } ${otherAdviser?.contactPhone || '-'}`,
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'E-Mail\n', style: 'label' },
                      {
                        text: otherAdviser?.contactEmail || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Address\n', style: 'label' },
                      {
                        text: Address.getAddress(otherAdviser?.address),
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  ''
                ],
                [
                  {
                    text: [
                      { text: 'Linked contact(s)\n', style: 'label' },
                      {
                        text:
                          helperService.getContactsByContentType({
                            contacts,
                            idContacts: otherAdviser.idContacts,
                            contentType: 'name'
                          }) || '-',
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  '',
                  '',
                  ''
                ]
              ]
            },
            layout: 'noBorders'
          });
          if (otherAdviser.isOtherAdviserAccountantType() && hasPersonContact) {
            content[content.length - 1].table.body[2][2] = {
              text: [
                { text: 'Linked employer(s)\n', style: 'label' },
                {
                  text:
                    helperService.getContactsByContentType({
                      contacts,
                      idEmployers: otherAdviser.idEmployers,
                      contentType: 'employer'
                    }) || '-',
                  style: 'value'
                }
              ],
              colSpan: 2
            };
          }

          if (
            otherAdviser.isOtherAdviserSolicitorType() &&
            workflow.isHomeLoan() &&
            $rootScope.hasBrokerToolsEnabled()
          ) {
            content[content.length - 1].table.body[2][2] = {
              text: [
                { text: 'Linked securities\n', style: 'label' },
                {
                  text: helperService.getLinkedHomeLoanSecurity({
                    securities: homeLoanSecurities,
                    idSecurity: otherAdviser.idAsset
                  }),
                  style: 'value'
                }
              ],
              colSpan: 2
            };
          }

          if (
            otherAdviser.isOtherAdviserGeneralInsuranceAgentType() &&
            workflow.isAssetFinance()
          ) {
            content[content.length - 1].table.body[2][2] = {
              text: [
                { text: 'Linked insurance\n', style: 'label' },
                {
                  text: helperService.getLinkedInsurance({
                    insurance,
                    idInsurance: otherAdviser.idInsurance
                  }),
                  style: 'value'
                }
              ],
              colSpan: 2
            };
          }
        }
        if (
          otherAdviser.isOtherAdviserPrimaryBankerType() &&
          displayingTypes.indexOf(otherAdviser.otherAdviserType.id) > -1
        ) {
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Bank\n', style: 'label' },
                      {
                        text: otherAdviser?.companyName || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Branch\n', style: 'label' },
                      {
                        text: otherAdviser?.bankBranch || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Title\n', style: 'label' },
                      {
                        text:
                          otherAdviser?.contactTitle?.name !== PersonalTitle.none.name
                            ? otherAdviser?.contactTitle?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Contact person (first name)\n', style: 'label' },
                      {
                        text: otherAdviser?.contactFirstName || '-',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Contact person (surname)\n', style: 'label' },
                      {
                        text: otherAdviser?.contactLastName || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Phone number\n', style: 'label' },
                      {
                        text: `${
                          otherAdviser?.contactPhone ? otherAdviser?.contactPhoneCode : ''
                        } ${otherAdviser?.contactPhone || '-'}`,
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'E-Mail\n', style: 'label' },
                      {
                        text: otherAdviser?.contactEmail || '-',
                        style: 'value'
                      }
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: [
                      { text: 'Address\n', style: 'label' },
                      {
                        text: Address.getAddress(otherAdviser?.address),
                        style: 'value'
                      }
                    ],
                    colSpan: 4
                  },
                  '',
                  '',
                  ''
                ],
                [
                  {
                    text: [
                      { text: 'Linked contact(s)\n', style: 'label' },
                      {
                        text:
                          helperService.getContactsByContentType({
                            contacts,
                            idContacts: otherAdviser.idContacts,
                            contentType: 'name'
                          }) || '-',
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  '',
                  '',
                  ''
                ]
              ]
            },
            layout: 'noBorders'
          });
          if (hasPersonContact) {
            content[content.length - 1].table.body[2][2] = {
              text: [
                { text: 'Linked employer(s)\n', style: 'label' },
                {
                  text:
                    helperService.getContactsByContentType({
                      contacts,
                      idEmployers: otherAdviser.idEmployers,
                      contentType: 'employer'
                    }) || '-',
                  style: 'value'
                }
              ],
              colSpan: 2
            };
          }
        }
      }
    }
    return content;
  };

  return {
    prepareOtherAdvisersDetails
  };
};
